import * as Yup from 'yup';

export const CourseValidationSchema = Yup.object().shape({
  nm_paroquia: Yup.string().trim().required('O campo paróquia é obrigatório.'),
  comarca_id: Yup.number().required('O campo comarca é obrigatório.'),
});
